import React from 'react';
import { BanknoteIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { currencies } from '../data/content';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const includes = ['6 tomos principales', '15 días de protocolo', '100+ recetas antiinflamatorias', 'Los 6 bonos estratégicos'];
const valueRows = [{
  label: '6 tomos principales',
  value: 'USD 35.00'
}, {
  label: '6 bonos complementarios',
  value: 'USD 63.00'
}];
const assurances = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: BanknoteIcon,
  label: 'Tarjeta, transferencia o pago local'
}];
type OfferProps = {
  showUrgency?: boolean;
};
export function Offer({
  showUrgency = true
}: OfferProps) {
  return <section id="oferta" className="bg-white py-20 sm:py-28" aria-labelledby="oferta-title" data-id="element-136" data-mp="2adwe2k3iydzj">
      <div className="mx-auto max-w-5xl px-6" data-id="element-137" data-mp="pkqoibtcjxat">
        {showUrgency ? <Reveal data-id="element-138" data-mp="pmbl06z81qbb">
            <div className="rounded-3xl bg-mint-50 px-6 py-10 sm:px-12" data-id="element-139" data-mp="uj1weh02zxqe">
              <CountdownTimer label="COMPRANDO DENTRO DE LAS PRÓXIMAS 24 HORAS" note="Después sube el precio y no vuelve a bajar." data-id="element-140" data-mp="ulem5gc2zce0" />
              
            </div>
          </Reveal> : null}

        <Reveal className={showUrgency ? 'mt-16' : ''} data-id="element-141" data-mp="13j728mpmmo2g">
          <div className="text-center" data-id="element-142" data-mp="6uipo5wojt0f">
            <h2 id="oferta-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-143" data-mp="6vkbn5f8hzwx">
              Elegí tu MegaPack
            </h2>
            <p className="mt-4 text-lg text-ink-soft" data-id="element-144" data-mp="ftcps697z1iq">
              Todas las opciones incluyen los 6 bonos estratégicos.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-145" data-mp="3k95k2ea7mxi6">
          <div className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-3xl border border-mint-300 bg-white shadow-lift" data-id="element-146" data-mp="3k7ufwdcurnqj">
            <p className="bg-mint-600 py-2.5 text-center text-sm font-semibold uppercase tracking-[0.16em] text-white" data-id="element-147" data-mp="3o8e9x824qb8g">
              Pack completo · el más elegido
            </p>

            <div className="grid gap-10 p-8 sm:p-12 md:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]" data-id="element-148" data-mp="qg4k7tr3nyjx">
              <div data-id="element-149" data-mp="1550pxk5oozhd">
                <h3 className="font-display text-3xl text-ink" data-id="element-150" data-mp="157mudaxa2yvd">Pack Completo</h3>
                <ul className="mt-6 space-y-3" data-id="element-151" data-mp="106z62x0fow4u">
                  {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-152" data-mp="cg39znoy3ers">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-600" aria-hidden="true" data-id="element-153" data-mp="7i1o6v04x1cm" />
                      <span className="text-[15px] text-ink-soft" data-id="element-154" data-mp="lhb742fq69ka">{item}</span>
                    </li>)}
                </ul>

                <dl className="mt-8 space-y-2 border-t border-mint-100 pt-6 text-sm" data-id="element-155" data-mp="hewmbcshwzqd">
                  {valueRows.map(row => <div key={row.label} className="flex justify-between gap-4" data-id="element-156" data-mp="1wvexkyn3tfkl">
                      <dt className="text-ink-muted" data-id="element-157" data-mp="1svwb3yfmwwfn">{row.label}</dt>
                      <dd className="text-ink-soft" data-id="element-158" data-mp="20enisfiplope">{row.value}</dd>
                    </div>)}
                  <div className="flex justify-between gap-4 font-semibold text-ink" data-id="element-159" data-mp="20h05t73bqp9b">
                    <dt data-id="element-160" data-mp="25bnogpbncpfz">Valor total real</dt>
                    <dd data-id="element-161" data-mp="1qh9e1d65eocx">USD 98.00</dd>
                  </div>
                </dl>
              </div>

              <div className="flex flex-col" data-id="element-162" data-mp="1vere0e26tt8s">
                <p className="text-sm text-ink-muted line-through" data-id="element-163" data-mp="1vhnbk1a4ifwp">USD 45.80</p>
                <p className="mt-1 font-display text-6xl leading-none text-mint-700" data-id="element-164" data-mp="2j5ndlxcvxsql">
                  USD 19.99
                </p>
                <p className="mt-4 inline-flex w-fit rounded-full bg-mint-100 px-3 py-1.5 text-sm font-semibold text-mint-800" data-id="element-165" data-mp="2o62qyox6308k">
                  Ahorrás USD 68.10 · 70% off
                </p>

                <div className="mt-8" data-id="element-166" data-mp="2ec2chwfzwin6">
                  <CtaButton className="w-full" data-id="element-167" data-mp="323r75jgahj7a">Quiero el Pack Completo 70% OFF</CtaButton>
                </div>

                <p className="mt-auto pt-6 text-xs leading-relaxed text-ink-muted" data-id="element-168" data-mp="36vrc5qb7v2aq">
                  El precio está expresado en dólares estadounidenses (USD). El
                  cobro se realiza automáticamente en la moneda de tu país al tipo
                  de cambio del momento.
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.04} data-id="element-169" data-mp="149nc44uh954g">
          <div className="mx-auto mt-10 max-w-3xl" data-id="element-170" data-mp="14af83grzl4v9">
            <p className="text-center text-sm font-medium text-ink" data-id="element-171" data-mp="21wmfszjl7dbu">
              Pagás en tu moneda local
            </p>
            <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-172" data-mp="1wxj8t9k1qx18">
              {currencies.map(currency => <li key={currency} className="whitespace-nowrap rounded-full bg-mint-50 px-3 py-1.5 text-xs text-ink-soft ring-1 ring-inset ring-mint-200" data-id="element-173" data-mp="1s6ay8a6zd5mh">
                  {currency}
                </li>)}
            </ul>

            <ul className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-174" data-mp="2koyencb17wh8">
              {assurances.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-175" data-mp="2fv416qm0sdql">
                  <item.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-176" data-mp="2o7ns25apaxlq" />
                  {item.label}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}